var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Editar Unidad de Negocio"}},[_c('formulario',{attrs:{"unidad-negocio":_vm.unidadNegocio,"paises-id":_vm.paisesId,"tarifa":_vm.tarifa,"opciones-paises":_vm.opcionesPaises,"opciones-tarifas":_vm.opcionesTarifas},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }